import { useCallback } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import InputItem from "../../../../app/generic/form/inputItem";

export const ibanFieldName = "iban";

const InternationalAccount = ({ formItemLayout }) => {
  const intl = useIntl();

  const handleIbanChange = useCallback(
    (e) => {
      const value = e.target.value.replace(/ /g, "");
      if (value) {
        const number = [...(value.substring(4) + value.substring(0, 4))]
          .map((c) =>
            c >= "0" && c <= "9" ? c : (c.charCodeAt() - 55).toString()
          )
          .join("");
        let first = (Number.parseInt(number.substring(0, 9)) % 97).toString();
        for (
          let index = 9, num = 7;
          index < number.length;
          num = Math.min(7, number.length - index), index += num
        ) {
          first = (
            Number.parseInt(first + number.substring(index, index + num)) % 97
          ).toString();
        }
        return first === "1"
          ? Promise.resolve()
          : Promise.reject(
              new Error(
                intl.formatMessage({
                  id: "registration.bank.iban.invalid",
                  defaultMessage: "IBAN není validní",
                })
              )
            );
      }
    },
    [intl]
  );

  return (
    <InputItem
      allowClear
      maxLength={34}
      minLength={16}
      fieldName={ibanFieldName}
      formItemLayout={formItemLayout}
      validatorFunction={handleIbanChange}
      label={
        <FormattedMessage id="registration.bank.iban" defaultMessage="IBAN" />
      }
      message={
        <FormattedMessage
          id="registration.bank.iban.empty"
          defaultMessage="IBAN je povinný"
        />
      }
    />
  );
};

export default InternationalAccount;
